import LabelsDashboardItem, { IGetLabelsDashboardItemDto } from "./LabelsDashboardItem"

export interface IGetLabelsDashboardDto {
    totalCount: number
    entities: IGetLabelsDashboardItemDto[]
}

export default class LabelsDashboard {
    totalCount: number
    items: LabelsDashboardItem[]

    constructor(dto: IGetLabelsDashboardDto) {
        this.totalCount = dto.totalCount
        this.items = dto.entities.map(e => new LabelsDashboardItem(e))
    }
}
